import { render, staticRenderFns } from "./legendBox16.vue?vue&type=template&id=e567d79c&scoped=true&"
import script from "./legendBox16.vue?vue&type=script&lang=js&"
export * from "./legendBox16.vue?vue&type=script&lang=js&"
import style0 from "./legendBox16.vue?vue&type=style&index=0&id=e567d79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e567d79c",
  null
  
)

export default component.exports